import dayjs from "dayjs"

import { dayjsFormats } from "../constants/dayjsFormats"

export const parseUnix = (unix: number) => {
  return dayjs.unix(unix).format(`${dayjsFormats.DATE} ${dayjsFormats.TIME}`)
}